import { render, staticRenderFns } from "./BaseNavigationLogo.vue?vue&type=template&id=4828d8fd&scoped=true"
import script from "./BaseNavigationLogo.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseNavigationLogo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BaseNavigationLogo.vue?vue&type=style&index=0&id=4828d8fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_underscore@1.13.6_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828d8fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/.pnpm/vuetify-loader@1.7.3_vue-template-compiler@2.7.14_vuetify@2.7.1_webpack@5.89.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VFlex,VImg})
